import { FC, lazy } from 'react';
import { useAuthorizationService } from 'src/apis/authorization-service/use-authorization-service';
import {
  UserAssignedPermissionGroupsRequest,
  useUserAssignedPermissionGroups,
} from 'src/apis/authorization-service/use-user-assigned-permission-groups';
import { PageSpinner } from 'src/components/spinner-container';
import { useOrganisationService } from 'src/pages/settings/organisation/use-organisation-service';
import { useMyUserDetails } from 'src/pages/settings/profile/use-my-user-details';

const Page = lazy(() => import('src/pages/settings/profile/page'));

export const Profile: FC = () => {
  const authorizationService = useAuthorizationService();
  const userAssignedPermissionGroups = useUserAssignedPermissionGroups({
    authorizationService,
  });

  return (
    <LoadOrganisationService
      userAssignedPermissionGroups={userAssignedPermissionGroups}
    />
  );
};

const LoadOrganisationService: FC<{
  userAssignedPermissionGroups: UserAssignedPermissionGroupsRequest;
}> = ({ userAssignedPermissionGroups }) => {
  const organisationService = useOrganisationService();
  const myUserDetails = useMyUserDetails({ organisationService });

  if (
    !myUserDetails.response ||
    userAssignedPermissionGroups?.response === null
  )
    return <PageSpinner />;

  return (
    <Page
      myUserDetails={myUserDetails}
      userAssignedPermissionGroups={userAssignedPermissionGroups}
    />
  );
};
